/**
 * Ordered level catalog.
 *
 * Gameplay content stays in level JSON. This small registry owns only the menu
 * metadata and lazy import boundary, so opening the level select does not boot
 * physics or pull every future house level into the initial bundle.
 */

export interface LevelCatalogEntry {
  id: string;
  /** Exact basename used by the dev editor's validated save endpoint. */
  fileName: string;
  chapter: string;
  name: string;
  room: string;
  icon: string;
  /** Null only for the first level. Later levels name the completion they need. */
  unlockAfter: string | null;
  /** Missing until that level's JSON has landed and passed validation. */
  load?: () => Promise<unknown>;
}

export const LEVEL_CATALOG: readonly LevelCatalogEntry[] = [
  {
    id: 'level1_living_room',
    fileName: 'level1.json',
    chapter: '1',
    name: 'The Vase',
    room: 'Living Room',
    icon: '🏺',
    unlockAfter: null,
    load: async () => (await import('@data/levels/level1.json')).default,
  },
  {
    id: 'level2_kitchen',
    fileName: 'level2.json',
    chapter: '2',
    name: 'Kitchen Caper',
    room: 'Kitchen',
    icon: '🐟',
    unlockAfter: 'level1_living_room',
    load: async () => (await import('@data/levels/level2.json')).default,
  },
  {
    id: 'level3_hall_bathroom',
    fileName: 'level3.json',
    chapter: '3',
    name: 'Splash Landing',
    room: 'Hall & Bathroom',
    icon: '🧻',
    unlockAfter: 'level2_kitchen',
    load: async () => (await import('@data/levels/level3.json')).default,
  },
];
